import React from 'react';
import { Widget } from 'shared/containers/portal_layout';

const Coverages = ({ coverages }) => (
  <Widget title="Coverage Statuses" className="nopadding" span={12}>
    {coverages ? (
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Code</th>
            <th>Description</th>
            <th>Covered?</th>
            <th>Further Check</th>
          </tr>
        </thead>
        <tbody>
          {coverages.map(k => (
            <tr
              key={k.type}
              className={`service ${k.coverageStatus === '1' ? 'covered' : 'not_covered'}`}
            >
              <td>{k.type}</td>
              <td>{k.typeLabel}</td>
              <td>
                <span className="covered-or-not">
                  {k.coverageStatus === '1' ? 'COVERED' : 'May Not Be Covered'}
                </span>
              </td>
              <td>
                <div>{k.coverageStatusLabel}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No coverage data</p>
    )}
  </Widget>
);

export default Coverages;
